import { Form } from '@ant-design/compatible';
import { Text } from '@react-pdf/renderer';
import { Card, Col, Collapse, Divider, Modal, Row, Tabs } from 'antd';
import AssetCatalogSingleItemDetails from 'components/AssetCatalogModal/AssetCatalogSingleItemDetail';
import GetLabel from 'DisplayFramework/components/GetLabel';
import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { toCurrency } from 'utils/utils';
import {
  AssetCatalogResponse,
  getAssetCatalogByKeyword,
  ParMarketingResponse,
} from '../../services/assetconfig';
import { CATALOG_IMG_URL } from '../../utils/config';

const { Panel } = Collapse;
const { TabPane } = Tabs;
type AssetCatalogPackItemDetailModalProps = {
  visible: boolean;
  Marketingitem: ParMarketingResponse;
  item: AssetCatalogResponse[];
  cataloglabel: any;
  onCancel: () => void;
  currcode?: string;
  onSelect: (items: AssetCatalogResponse, nbasset: number) => void;
};
const AssetCatalogPackItemDetailModal = (
  props: AssetCatalogPackItemDetailModalProps
) => {
  const {
    visible,
    onCancel,
    cataloglabel,
    currcode,
    onSelect,
    item,
    Marketingitem,
  } = props;

  const closeDetails = useCallback(() => {
    setDetailsVisible(false);
  }, []);

  const openDetails = useCallback(() => {
    setDetailsVisible(true);
  }, []);

  const { data: assetsCatalog } = useQuery(
    ['getAssetCatalogByKeyword', { cataloglabel }],
    () =>
      getAssetCatalogByKeyword({
        keyword: cataloglabel,
        filters: '',
        mcid: '',
        mgid: '',
        networkcode: '',
        tpidbroker: '',
        currcode: currcode,
      } as any).then((res) => res.list || []),
    {
      enabled: Boolean(cataloglabel),
      staleTime: 30 * 1000,
    }
  );
  let items = props.item || assetsCatalog;
  const [detailsVisible, setDetailsVisible] = useState(false);

  const imageSrc = CATALOG_IMG_URL + Marketingitem?.pictureurl;

  return item ? (
    <Modal
      visible={visible}
      title={Marketingitem.mclabel}
      footer={null}
      onCancel={onCancel}
      width="700px"
      bodyStyle={{
        overflowY: 'auto',
        maxHeight: 'calc(120vh - 200px)',
      }}
    >
      <Card>
        <Row justify="center">
          <Col span={12}>
            <img alt="example" style={{ width: '300px' }} src={imageSrc} />
          </Col>
        </Row>

        <Divider orientation="left" />
        <Row style={{ marginLeft: '5px' }}>
          <Col style={{ color: 'black' }} span={14}>
            <strong style={{ fontSize: '20px' }}>
              <GetLabel label="Description : " />
            </strong>
            <br />
            {Marketingitem?.parMarketingLabels.map(
              (label) => label.mcdescription
            )}
          </Col>
          <Col span={8} style={{ marginLeft: '50px', color: 'black' }}>
            <strong>
              <div style={{ marginLeft: '80px', fontSize: '20px' }}>
                {toCurrency(Marketingitem.assetnetamount, currcode ?? localStorage.getItem('currcode') ?? '')}
              </div>
            </strong>
          </Col>
        </Row>
        <strong
          style={{ color: 'black', marginBottom: '10px', fontSize: '19px' }}
        >
          <GetLabel label="Assets" />
        </strong>

        <Form layout="vertical">
          <Collapse bordered={false} expandIconPosition="left" accordion>
            {items?.map((item, index) => (
              <Panel
                key={index}
                style={{ backgroundColor: '#f0f0f0' }}
                header={
                  <Text>
                    {item?.assetlabel}{' '}
                    {item?.assetnetamountorigine > item?.assetdiscountamount &&
                    item?.assetdiscountperc !== 0 &&
                    item?.assetdiscountperc != null ? (
                      <strong
                        style={{
                          color: 'black',
                          float: 'right',
                        }}
                      >
                        &nbsp;{' '}
                        {toCurrency(
                          item.assetnetamountorigine -
                            item?.assetdiscountamount,
                          currcode ?? localStorage.getItem('currcode') ?? ''
                        )}
                      </strong>
                    ) : (
                      <strong
                        style={{
                          color: 'black',
                          float: 'right',
                        }}
                      >
                        {toCurrency(
                          item.assetnetamountorigine,
                          currcode ?? localStorage.getItem('currcode') ?? ''
                        )}
                      </strong>
                    )}
                  </Text>
                }
              >
                <Row>
                  <Card className="AssetCatalogPackItem" bordered={false}>
                    <AssetCatalogSingleItemDetails
                      currcode={item.currcode}
                      item={item}
                    />
                  </Card>
                </Row>
              </Panel>
            ))}
          </Collapse>
        </Form>
      </Card>
    </Modal>
  ) : null;
};

export default AssetCatalogPackItemDetailModal;
